module.exports = __webpack_public_path__ + "media/images/pc/special_reports/separator_suns-42e3400509a474d2665e3f5ac6b121fd.jpg";